import { render, staticRenderFns } from "./user-coupon.vue?vue&type=template&id=6c57cf2b&scoped=true"
import script from "./user-coupon.vue?vue&type=script&lang=js"
export * from "./user-coupon.vue?vue&type=script&lang=js"
import style0 from "./user-coupon.vue?vue&type=style&index=0&id=6c57cf2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57cf2b",
  null
  
)

export default component.exports